/**
 * Runtime mirrors of the carrier enums in api/db/schema.prisma. The web bundle
 * cannot import @prisma/client, so anything a component switches on lives here.
 */

export enum VoEProvider {
  TENSTREET = 'TENSTREET',
  DRIVER_REACH = 'DRIVER_REACH',
  TRUCK_RIGHT = 'TRUCK_RIGHT',
  CDL_SUITE = 'CDL_SUITE',
  DOUBLE_NICKEL = 'DOUBLE_NICKEL',
  DRIVER_FACTS = 'DRIVER_FACTS',
  DRIVER_IQ = 'DRIVER_IQ',
  THE_WORK_NUMBER = 'THE_WORK_NUMBER',
  OTHER = 'OTHER',
}

export enum CarrierVerificationPlatformSource {
  ADMIN = 'ADMIN',
  VOICE_AGENT = 'VOICE_AGENT',
  IMPORT = 'IMPORT',
  VOE_RESPONSE = 'VOE_RESPONSE',
}

export const CARRIER_VERIFICATION_PLATFORM_SOURCE_LABEL: Record<
  CarrierVerificationPlatformSource,
  string
> = {
  ADMIN: 'Set by an admin',
  VOICE_AGENT: 'Heard by the voice agent',
  IMPORT: 'Imported',
  VOE_RESPONSE: 'Answered a verification through Double Nickel',
}

export enum CarrierCurationStatus {
  UNREVIEWED = 'UNREVIEWED',
  REVIEWED = 'REVIEWED',
  LOCKED = 'LOCKED',
}

export const CARRIER_CURATION_STATUS_LABEL: Record<
  CarrierCurationStatus,
  string
> = {
  UNREVIEWED: 'Unreviewed',
  REVIEWED: 'Reviewed',
  LOCKED: 'Locked',
}

/**
 * What each rung means for the paths that write the directory automatically:
 * driver applications, the VoE request and response forms, the voice agent.
 * Mirrors CURATION_STATUS_DESCRIPTION on the API so the copy matches the rule.
 */
export const CARRIER_CURATION_STATUS_DESCRIPTION: Record<
  CarrierCurationStatus,
  string
> = {
  UNREVIEWED:
    'Any source may update this carrier and add contacts. FMCSA refreshes names and address on every save.',
  REVIEWED:
    'Automated sources may only fill fields that are empty. Existing values, including admin corrections, are kept. New contacts are still added.',
  LOCKED:
    'Only the admin portal may change this carrier or its contacts. Driver applications, VoE forms and the voice agent are ignored.',
}
